export default "/_next/static/images/service-health-desktop-2x-5b6ae1e06c2a9b0bfb9f9057f26f606e.jpg";